import {getAccountsWebUrl} from "../../env/env";
import {IntegrationApp} from "./app-names";

export const useGoogleAuthUri = (originURI: string, prompt: string) => {
  return {
    googleDriveAuthUri: createGoogleDriveAuthUri(originURI, prompt),
  }
};

function createGoogleDriveAuthUri(openerURI: string, prompt: string) {
  const props: authProps = {
    client_id: "808303802888-eoirfps8q3caurm7hhlfge3ffd2fj8g6.apps.googleusercontent.com",
    scope: "https://www.googleapis.com/auth/drive.metadata.readonly",
    redirect_uri: getAccountsWebUrl(`/integrations/${IntegrationApp.GoogleDrive}/post-auth`),
    response_type: "token",
    prompt,
    state: openerURI,
  }
  return createGoogleAuthUri(props);
}

type authProps = {
  [id: string]: string;
}

function createGoogleAuthUri(props: authProps) {
  // https://developers.google.com/identity/protocols/oauth2/web-server#sample-oauth-2.0-server-response
  const u = new URL("https://accounts.google.com/o/oauth2/v2/auth");
  for (const k in props) {
    u.searchParams.set(k, props[k]);
  }
  return u;
}

